import type { GridSpaceDataType } from 'data/types';
import {
  useRef,
  useState,
  type Dispatch,
  type MutableRefObject,
  type SetStateAction
} from 'react';

export type StructureGridPanOffset = { x: number; y: number };

export type UseStructureGridResult = {
  activeDragData: any;
  setActiveDragData: Dispatch<SetStateAction<any>>;
  activeId: string | null;
  setActiveId: Dispatch<SetStateAction<string | null>>;
  draggedSectionSpaces: GridSpaceDataType[];
  setDraggedSectionSpaces: Dispatch<SetStateAction<GridSpaceDataType[]>>;
  show3DView: boolean;
  setShow3DView: Dispatch<SetStateAction<boolean>>;
  gridZoom: number;
  setGridZoom: Dispatch<SetStateAction<number>>;
  gridPanOffset: StructureGridPanOffset;
  setGridPanOffset: Dispatch<SetStateAction<StructureGridPanOffset>>;
  gridZoomRef: MutableRefObject<number>;
  gridPanOffsetRef: MutableRefObject<StructureGridPanOffset>;
};

export function useStructureGrid(): UseStructureGridResult {
  const [activeDragData, setActiveDragData] = useState<any>(null);
  const [activeId, setActiveId] = useState<string | null>(null);
  const [draggedSectionSpaces, setDraggedSectionSpaces] = useState<
    GridSpaceDataType[]
  >([]);
  const [show3DView, setShow3DView] = useState(false);
  const [gridZoom, setGridZoom] = useState(1);
  const [gridPanOffset, setGridPanOffset] = useState<StructureGridPanOffset>({
    x: 0,
    y: 0
  });

  const gridZoomRef = useRef(gridZoom);
  gridZoomRef.current = gridZoom;
  const gridPanOffsetRef = useRef(gridPanOffset);
  gridPanOffsetRef.current = gridPanOffset;

  return {
    activeDragData,
    setActiveDragData,
    activeId,
    setActiveId,
    draggedSectionSpaces,
    setDraggedSectionSpaces,
    show3DView,
    setShow3DView,
    gridZoom,
    setGridZoom,
    gridPanOffset,
    setGridPanOffset,
    gridZoomRef,
    gridPanOffsetRef
  };
}
